import { FC, SVGProps } from "react";

const RelationshipIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="50"
      height="56"
      viewBox="0 0 50 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity=".3"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="matrix(1 0 0 -1 21 29)"
        fill="#4BB1E9"
      />
      <path
        d="M1.964 33.242a18.1 18.1 0 0 1-.772-5.248C1.192 18.056 9.197 10 19.07 10s17.878 8.056 17.878 17.994c0 1.826-.27 3.588-.772 5.248"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M37.416 32.758a.428.428 0 0 0-.309-.11c-2.702.13-5.639.566-9.24 1.374a.418.418 0 0 0-.267.193.395.395 0 0 0-.037.322l.35 1.096c-2.655-.978-6.389-1.541-9.62-1.418-1.185 0-2.538.572-3.774 1.42H9.632l.35-1.099a.395.395 0 0 0-.037-.322.415.415 0 0 0-.267-.193c-3.6-.807-6.537-1.244-9.24-1.374a.43.43 0 0 0-.308.111.402.402 0 0 0-.13.294V46.98c0 .224.187.406.417.406h5.164a.416.416 0 0 0 .398-.286l.197-.618c4.25 4.815 8.571 9.237 11.946 9.237.65 0 1.263-.167 1.835-.523l.088.087a2.12 2.12 0 0 0 1.486.606h.013c.559 0 1.084-.209 1.48-.589.348-.334.542-.76.599-1.198a2.132 2.132 0 0 0 2.817-.111c.463-.445.66-1.047.607-1.633.186.045.375.075.563.075.536 0 1.06-.18 1.439-.544.399-.383.62-.896.624-1.444a1.974 1.974 0 0 0-.579-1.423c-.154-.183-.312-.36-.468-.54l2.844-1.683.096.3c.054.17.215.286.398.286h5.164a.41.41 0 0 0 .417-.405V33.052a.4.4 0 0 0-.13-.294ZM5.273 46.574H.834V33.481c2.422.146 5.057.541 8.218 1.234l-3.779 11.86Zm23.19 4.737c-.476.457-1.382.408-1.901-.104-.007-.007-.017-.01-.024-.016-.028-.03-.05-.066-.08-.096L21.89 46.6a.427.427 0 0 0-.59-.003.398.398 0 0 0-.004.574l4.568 4.495c.238.234.367.545.365.877a1.21 1.21 0 0 1-.376.87 1.299 1.299 0 0 1-1.798-.01l-1.011-.996-.002-.002-4.568-4.495a.427.427 0 0 0-.59-.004.398.398 0 0 0-.004.574l4.568 4.496a1.213 1.213 0 0 1-.01 1.748 1.299 1.299 0 0 1-1.799-.01l-5.582-5.494a.425.425 0 0 0-.59-.003.397.397 0 0 0-.003.573l4.885 4.808c-3.101 1.612-8.239-3.747-12.88-9.03l2.905-9.12h4.094c-1.143.986-2.086 2.164-2.541 3.237-.582 1.373-.203 2.146.217 2.552l.035.03c1.603 1.235 3.182 1.547 5.641-.926.835.05 1.546-.092 2.163-.432 3.465 2.355 6.648 5.256 9.49 8.656a1.212 1.212 0 0 1-.01 1.747Zm-.38-3.457c-2.672-3.005-5.643-5.614-8.85-7.765a.426.426 0 0 0-.474 0c-.551.367-1.226.507-2.062.427a.419.419 0 0 0-.345.126c-2.33 2.41-3.481 1.888-4.635 1.003-.415-.421-.24-1.13-.019-1.652.928-2.19 4.22-4.966 6.61-4.967 3.41-.127 7.364.518 9.924 1.61L31.215 46l-3.132 1.854Zm8.628-1.28h-4.44l-3.778-11.859c3.16-.693 5.796-1.088 8.218-1.234v13.093Z"
        fill="#2C2C2C"
      />
      <path
        d="M13.707 30.263V29.24c0-2.257 1.897-4.087 4.238-4.087h4.238c2.34 0 4.238 1.83 4.238 4.087v1.022m0-8.173c1.755 0 3.178-1.373 3.178-3.065 0-1.693-1.423-3.065-3.178-3.065m6.357 14.303V29.24c0-2.257-1.898-4.087-4.238-4.087h-.53m-4.768-6.13c0 1.693-1.423 3.066-3.178 3.066-1.756 0-3.178-1.373-3.178-3.065 0-1.693 1.422-3.065 3.178-3.065 1.755 0 3.178 1.372 3.178 3.065Zm-9.733 3.067c-1.756 0-3.179-1.373-3.179-3.065 0-1.693 1.423-3.065 3.179-3.065M7.152 30.263V29.24c0-2.257 1.897-4.087 4.238-4.087h.53"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="21.216" cy="18.105" r=".358" fill="#2C2C2C" />
      <circle cx="18.832" cy="18.105" r=".358" fill="#2C2C2C" />
      <path
        d="M18.475 19.834s.395.893 1.49.893c1.094 0 1.49-.893 1.49-.893"
        stroke="#2C2C2C"
        strokeWidth=".6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default RelationshipIcon;
